import { useState } from "react";
import { Box, Card, Container, Stack, Tab, Tabs, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BarChart, CalendarMonth, CalendarViewMonth, TableRows } from "@mui/icons-material";
import TimesheetWeek from "./TimesheetWeek";
import TimesheetReport from "./TimesheetReport";
import TimesheetCalendar from "./TimesheetCalendar";
import { panelSx } from "../projects/projectUtils";

// Weekly timesheet (own hours only) and the time report (everyone, everything - for now).
function TimesheetView() {
    const theme = useTheme();
    const [tab, setTab] = useState(0);
    const [reportView, setReportView] = useState<'summary' | 'calendar'>('summary');

    return (
        <Box sx={{ backgroundColor: theme.palette.grey[100], minHeight: 'calc(100vh - 64px)', paddingY: 2 }}>
            <Container maxWidth="xl">
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ sm: 'center' }} gap={1} sx={{ marginBottom: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>Timesheet</Typography>
                    <Tabs value={tab} onChange={(_, value) => setTab(value)}>
                        <Tab icon={<CalendarMonth fontSize="small" />} iconPosition="start" label="Your week" />
                        <Tab icon={<BarChart fontSize="small" />} iconPosition="start" label="Time report" />
                    </Tabs>
                </Stack>
                {tab === 0 ? <TimesheetWeek /> : (
                    <>
                        <ToggleButtonGroup size="small" exclusive value={reportView} onChange={(_, value) => value && setReportView(value)} sx={{ marginBottom: 1.5, backgroundColor: 'background.paper' }}>
                            <ToggleButton value="summary"><TableRows fontSize="small" sx={{ marginRight: 0.75 }} />Summary</ToggleButton>
                            <ToggleButton value="calendar"><CalendarViewMonth fontSize="small" sx={{ marginRight: 0.75 }} />Month calendar</ToggleButton>
                        </ToggleButtonGroup>
                        {reportView === 'summary'
                            ? <TimesheetReport />
                            : <Card elevation={0} sx={{ ...panelSx(theme), overflow: 'hidden' }}><TimesheetCalendar /></Card>}
                    </>
                )}
            </Container>
        </Box>
    );
}

export default TimesheetView;
